/** SA-989: a failed request's body, worded. FastAPI's `detail` may be a
 * string, a coded object (`{code, message}`) or a validation list
 * (`[{loc, msg, …}]`); each reads as its sentence and anything else as the
 * caller's fallback, so a bare object or code is never printed. */
export function errorDetailText(body: unknown, fallback: string): string {
  const detail = body && typeof body === 'object' && 'detail' in body ? (body as { detail: unknown }).detail : undefined
  if (typeof detail === 'string' && detail) return detail
  if (Array.isArray(detail)) return sentence((detail[0] as { msg?: unknown } | undefined)?.msg, fallback)
  if (detail && typeof detail === 'object') return sentence((detail as { message?: unknown }).message, fallback)
  return fallback
}

function sentence(value: unknown, fallback: string): string {
  return typeof value === 'string' && value ? value : fallback
}
